var _defs, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCxqqreer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "132.29167mm",
    height: "43.524548mm",
    viewBox: "0 0 132.29167 43.524548",
    id: "svg94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-9.0826126e-7,-253.47545)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 117.83928,
    id: "text98"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan100",
    x: 16.630953,
    y: 127.62886
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 111.03571,
    id: "text104"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan102",
    x: 16.630953,
    y: 158.02571,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g330",
    transform: "matrix(0.44514626,0,0,0.44514626,5.0395216e-7,164.79156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 29.104245,272.34558 C 27.179998,270.66186 24.534157,269.82 21.407255,269.82 9.5009732,269.82 9.0826126e-7,278.59938 9.0826126e-7,287.98009 9.0826126e-7,293.63257 4.5700889,297 10.463097,297 c 9.621238,0 21.52752,-9.01991 21.52752,-18.16009 v -79.61574 h -2.886372 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    },
    id: "path307"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 92.732199,236.55475 c 0,-3.4877 -2.886371,-6.37407 -6.37407,-6.37407 -3.607964,0 -6.494336,2.88637 -6.494336,6.37407 0,2.04451 1.202655,3.8485 2.645841,4.93088 0.841858,0.60133 1.683716,1.08239 2.64584,1.32292 0.721593,0.12027 1.683717,0.3608 2.525575,0.3608 1.32292,0 2.64584,-0.3608 3.72823,-0.72159 1.32292,-0.3608 2.164778,-0.72159 3.487698,-1.44319 0.120266,-0.12026 0.360797,-0.12026 0.481062,-0.12026 0.360797,0 0.481062,0.48106 0.481062,0.96212 0,0.24053 0,0.60133 -0.120265,0.96212 -0.240531,1.44319 -7.215929,20.68567 -8.899645,26.93947 0,1.20266 2.164778,1.32292 2.766106,1.32292 1.082389,0 2.405309,-0.24053 3.367433,-0.96212 0.240531,-0.24053 9.7415,-34.03513 9.7415,-34.03513 0.3608,-1.68372 0.84186,-3.24717 0.96213,-3.72823 0,-0.96212 -0.96213,-1.44319 -1.20266,-1.56345 -0.24053,0 -0.48106,0 -1.08239,0.48106 -0.60132,0.48106 -5.411943,6.2538 -8.659111,6.2538 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    },
    id: "path309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 170.94233,250.50555 c 1.56345,1.92424 2.88637,3.84849 4.20929,5.77274 0.12027,0.48106 0.60133,1.20265 0.60133,1.44318 0,0 0,0.24053 -0.12027,0.3608 -0.24053,0.3608 -0.60132,0.48106 -1.08239,0.48106 -0.36079,0 -1.20265,-0.24053 -1.56345,-0.36079 -0.48106,0 -1.08239,-0.24054 -1.56345,-0.24054 -4.08902,0 -7.81725,4.08903 -7.81725,9.26045 0,4.81061 4.08902,9.50097 11.18469,14.91291 0.72159,0.60133 1.68371,0.84186 2.40531,0.84186 0.72159,0 1.44318,-0.24053 1.44318,-0.60132 0.12027,-0.24054 0.24053,-0.48107 0.24053,-0.60133 0,-0.96213 -0.72159,-1.68372 -1.56345,-2.40531 -1.20265,0 -2.28504,-2.52558 -2.52557,-3.36743 -0.24054,-0.84186 -0.3608,-1.68372 -0.3608,-2.52558 0,-3.00664 1.44318,-6.37407 4.57009,-6.9754 0.48106,-0.12026 0.96212,-0.12026 1.56345,-0.12026 2.7661,0 5.89301,1.08239 7.45646,1.68371 0.12026,0 0.24053,0.12027 0.24053,0.12027 0.3608,0.12027 0.48106,0.12027 0.72159,0.12027 0.24053,0 0.48106,-0.12027 0.48106,-0.48107 0,-1.08239 -2.52557,-4.32955 -3.60796,-5.41194 -3.60797,-4.44983 -6.6146,-8.05779 -6.6146,-13.34947 0,-0.48106 0.12026,-0.96212 0.12026,-1.32292 0.3608,-5.53221 3.8485,-10.22257 6.37407,-14.07106 0.24053,-0.48106 0.3608,-0.96212 0.3608,-1.44319 0,-0.96212 -0.3608,-1.92424 -0.3608,-1.92424 0,0 -14.31159,-16.83717 -15.87504,-18.52089 -0.48106,-0.48106 -1.20265,-0.72159 -1.80398,-0.72159 -0.96212,0 -1.92425,0.60133 -1.92425,1.92425 0,0.48106 0.12027,0.96212 0.48106,1.56345 0.3608,1.08239 5.77275,6.01327 5.77275,12.8684 0,3.60797 -1.44319,7.69699 -5.77275,12.26708 -0.96212,0.96213 -1.32292,2.04452 -1.32292,2.76611 0,1.32292 0.96213,2.28504 0.96213,2.28504 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    },
    id: "path311"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 244.95446,226.2839 c -4.93089,-7.57672 -9.01991,-15.51424 -10.4631,-24.77469 -0.3608,-1.56345 -1.08239,-2.04451 -2.88637,-2.04451 -0.48106,0 -0.96212,0.12027 -0.96212,0.84186 v 0.12027 c 0,0 0,0.24053 0,0.48106 v 22.60991 c 0,0 0,0 0,0 v 48.58725 c -1.92425,-1.68372 -4.57009,-2.52558 -7.697,-2.52558 -11.90628,0 -21.40725,8.77938 -21.40725,18.03982 0,5.65248 4.57009,9.01991 10.4631,9.01991 9.62123,0 21.52752,-8.89964 21.52752,-18.03982 v -53.99919 c 5.893,3.72822 12.98867,14.31159 15.9953,21.28698 1.44319,3.24717 2.28505,8.77938 2.28505,14.43186 0,4.32956 -0.60133,8.89965 -2.28505,13.2292 -0.12026,0.48106 -0.24053,0.96213 -0.24053,1.44319 0,1.44318 0.96213,2.40531 1.56345,2.7661 l 0.12027,0.12027 c 0.84186,0 2.04451,-0.3608 2.52557,-1.92425 0,0 2.52558,-9.14017 2.52558,-16.7169 0,-12.02655 -5.05115,-23.3315 -11.06442,-32.95274 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    },
    id: "path313"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(117.92857,16.92532)",
    id: "g241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path228",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.66894257
    },
    d: "m 151.92144,280.07468 h -7.79057 v -9.29002 h 7.79057 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path230",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.66894257
    },
    d: "m 165.58992,280.07468 h -7.79057 v -9.29002 h 7.79057 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path232",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.66894257
    },
    d: "m 179.2584,280.07468 h -7.79057 v -9.29002 h 7.79057 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.37839078,0,0,0.37839078,27.608102,242.53376)",
    id: "text283",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "76.76551819px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.91913795
    },
    "aria-label": ","
  }, /*#__PURE__*/React.createElement("path", {
    id: "path285",
    style: {
      strokeWidth: 1.91913795
    },
    d: "m 240.56434,119.39031 -10.57025,24.55147 h -5.47254 l 6.52207,-24.55147 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCxqqreer);
export default __webpack_public_path__ + "static/media/cxqqreer.e3fad618284ee0ef4bf771014adbba56.svg";
export { ForwardRef as ReactComponent };